"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = _interopRequireDefault(require("immutable"));

var _formatters = require("../utils/formatters");

var _ReviewSteps = require("../constants/reviews/ReviewSteps");

var _ReviewAxes = require("../constants/reviews/ReviewAxes");

var ReviewQuestions = _interopRequireWildcard(require("../constants/reviews/ReviewQuestions"));

var _CompanySize = require("../constants/reviews/CompanySize");

var defaults = {
  id: null,
  offeringId: null,
  offeringName: null,
  // Admin endpoint only
  offeringPortalId: null,
  // Admin endpoint only
  fullName: null,
  // Admin endpoint only
  displayName: null,
  // Customer endpoint only
  portalId: null,
  // Customer endpoint only
  userId: null,
  // Customer endpoint only
  avatarUrl: null,
  showAvatar: true,
  industry: null,
  employees: null,
  createdAt: null,
  ratings: new _immutable.default.Map(),
  answers: new _immutable.default.Map(),
  reply: new _immutable.default.Map(),
  archivedReplies: new _immutable.default.List(),
  attributes: new _immutable.default.List(),
  archived: false
};

var Review = /*#__PURE__*/function (_Immutable$Record) {
  (0, _inherits2.default)(Review, _Immutable$Record);

  function Review() {
    (0, _classCallCheck2.default)(this, Review);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Review).apply(this, arguments));
  }

  (0, _createClass2.default)(Review, [{
    key: "isStepComplete",
    value: function isStepComplete(step, checkedLegalDisclaimer) {
      var _this = this;

      switch (step) {
        case _ReviewSteps.ReviewSteps.RATE:
          return Object.values(_ReviewAxes.ReviewAxes).every(function (axis) {
            return axis === _ReviewAxes.ReviewAxes.SUPPORT_DOCS || !!_this.ratings.get(axis);
          });

        case _ReviewSteps.ReviewSteps.SHARE:
          return this.answers.get(ReviewQuestions.TITLE) && this.answers.get(ReviewQuestions.TITLE).length < 100 && this.answers.get(ReviewQuestions.FOR) && this.answers.get(ReviewQuestions.REVIEW) && this.answers.get(ReviewQuestions.REVIEW).length >= 75;

        case _ReviewSteps.ReviewSteps.ABOUT:
          return this.industry && this.employees && checkedLegalDisclaimer;

        default:
          return false;
      }
    }
  }, {
    key: "getHelpfulCount",
    value: function getHelpfulCount() {
      return this.attributes.filter(function (attr) {
        return attr.get('helpful');
      }).size;
    }
  }, {
    key: "toggleHelpful",
    value: function toggleHelpful(reviewId, userId, helpful) {
      var indexToUpdate = this.attributes.findIndex(function (attr) {
        return attr.get('userId') === userId;
      });

      if (indexToUpdate !== -1) {
        return this.set('attributes', this.attributes.update(indexToUpdate, function (attr) {
          return attr.set('helpful', helpful);
        }));
      }

      return this.set('attributes', this.attributes.push(new _immutable.default.Map({
        reviewId: reviewId,
        userId: userId,
        helpful: helpful
      })));
    }
  }, {
    key: "getQualityRatings",
    value: function getQualityRatings() {
      var qualityRatingsMap = this.ratings.delete(_ReviewAxes.ReviewAxes.OVERALL);
      return _ReviewAxes.QualityRatingsTemplate.merge(qualityRatingsMap);
    }
  }, {
    key: "setOverallRating",
    value: function setOverallRating(overallRating) {
      return this.setIn(['ratings', _ReviewAxes.ReviewAxes.OVERALL], overallRating);
    }
  }], [{
    key: "from",
    value: function from(data) {
      return new Review(_immutable.default.fromJS((0, _formatters.cleanObject)(data)));
    }
  }, {
    key: "fromArray",
    value: function fromArray(data) {
      return data.map(function (review) {
        return Review.from(review);
      });
    }
  }, {
    key: "toEmployeeString",
    value: function toEmployeeString(range) {
      var rangeKey;
      var formattedMin;
      var formattedMax;

      if (range === _CompanySize.PREFER_NOT_TO_SAY) {
        rangeKey = 'undisclosed';
      } else {
        var _range$split = range.split('_'),
            _range$split2 = (0, _slicedToArray2.default)(_range$split, 3),
            __range = _range$split2[0],
            min = _range$split2[1],
            max = _range$split2[2];

        formattedMin = _I18n.default.toNumber(min);
        formattedMax = _I18n.default.toNumber(max);
        rangeKey = min === '1' ? 'single' : max ? 'range' : 'indefinite';
      }

      return _I18n.default.text("ecosystemMarketplaceCore.reviews.employees." + rangeKey, {
        min: formattedMin,
        max: formattedMax
      });
    }
  }]);
  return Review;
}(_immutable.default.Record(defaults));

exports.default = Review;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/records/Review.js
// module id = 61
// module chunks = 209 210 211 212